import * as handler from './handler';
import {
  PATH_AUTOMATED_STRATEGIES,
  PATH_USER_DETAILS,
  PATH_SUBSCRIPTIONS,
  PATH_STRATEGIES_SUB_PLANS,
  PATH_PORTFOLIOS,
  PAYPAL_SANDBOX_BASE_URL,
} from './path';

const getAutomatedStrategies = () =>
  handler.get(PATH_AUTOMATED_STRATEGIES).then((res) => {
    return res;
  });

const getStrategyDetails = (id) =>
  handler.get(`${PATH_AUTOMATED_STRATEGIES}/${id}`).then((res) => {
    return res;
  });

const getMonthlyReturn = (id, monthYear) =>
  handler.get(`${PATH_AUTOMATED_STRATEGIES}/${id}/chart-data/monthly-return/${monthYear}`).then((res) => {
    return res;
  });

const getAnnualReturn = (id) =>
  handler.get(`${PATH_AUTOMATED_STRATEGIES}/${id}/chart-data/annual`).then((res) => {
    return res;
  });

const getHistoricalBacktesting = (id) =>
  handler.get(`${PATH_AUTOMATED_STRATEGIES}/${id}/chart-data/historical-backtesting`).then((res) => {
    return res;
  });

const getDrawdown = (id) =>
  handler.get(`${PATH_AUTOMATED_STRATEGIES}/${id}/chart-data/drawdown`).then((res) => {
    return res;
  });

const getUserStrategies = (id) =>
  handler.get(`${PATH_USER_DETAILS}protected-routes/${id}/strategies`).then((res) => {
    return res;
  });

const startStrategy = (userId, payload) =>
  handler.post(`${PATH_USER_DETAILS}protected-routes/${userId}/strategies`, payload).then((res) => {
    return res;
  });

const getSubscriptionDetails = (userId, id) =>
  handler.get(`${PATH_SUBSCRIPTIONS + userId}/strategies/${id}`).then((res) => {
    return res;
  });

const getStrategySubscriptions = (id) =>
  handler.get(`${PATH_STRATEGIES_SUB_PLANS}/strategies/${id}`).then((res) => {
    return res;
  });

const userSubscribeToStrategy = (userId, payload) =>
  handler.post(`${PATH_SUBSCRIPTIONS + userId}/strategy`, payload).then((res) => {
    return res;
  });

const pauseStrategy = (userId, portfolioId, strategyId) =>
  handler.delet(`${PATH_PORTFOLIOS + userId}/${portfolioId}/strategies/${strategyId}`).then((res) => {
    return res;
  });

const stopStrategy = (userId, portfolioId, strategyId) =>
  handler.post(`${PATH_PORTFOLIOS + userId}/${portfolioId}/strategies/${strategyId}`).then((res) => {
    return res;
  });

const getAllocation = (id) =>
  handler.get(`${PATH_AUTOMATED_STRATEGIES}/${id}/chart-data/allocation`).then((res) => {
    return res;
  });

const deployStrategy = (strategyId, payload) =>
  handler.put(`${PATH_AUTOMATED_STRATEGIES}/${strategyId}`, payload).then((res) => {
    return res;
  });

const getCreatedStrategy = () =>
  handler.get(`${PATH_AUTOMATED_STRATEGIES}/createdByMe`).then((res) => {
    return res;
  });

const createBot = (payload) =>
  handler.post(PATH_AUTOMATED_STRATEGIES, payload).then((res) => {
    return res;
  });

const updateMetaData = (strategyId, payload) =>
  handler.put(`${PATH_AUTOMATED_STRATEGIES}/${strategyId}/meta-data`, payload).then((res) => {
    return res;
  });

const deleteStrategy = (strategyId) =>
  handler.delet(`${PATH_AUTOMATED_STRATEGIES}/${strategyId}`).then((res) => {
    return res;
  });

const stopPaypalPlan = (subscriptionId, payload) =>
  handler
    .post(`${PAYPAL_SANDBOX_BASE_URL}/v1/billing/subscriptions/${subscriptionId}/cancel`, payload, {
      withCredentials: false,
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_PAYPAL_TOKEN}`,
      },
    })
    .then((res) => {
      return res;
    });

export default {
  getAutomatedStrategies,
  getStrategyDetails,
  getMonthlyReturn,
  getAnnualReturn,
  getHistoricalBacktesting,
  getDrawdown,
  getUserStrategies,
  startStrategy,
  getSubscriptionDetails,
  getStrategySubscriptions,
  userSubscribeToStrategy,
  pauseStrategy,
  stopStrategy,
  getAllocation,
  deployStrategy,
  getCreatedStrategy,
  createBot,
  updateMetaData,
  deleteStrategy,
  stopPaypalPlan,
};
